import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ContentfulClient, ContentfulProvider } from 'react-contentful';
import * as Sentry from '@sentry/react';
import './index.css';

(async () => {

  if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
    Sentry.init({
      dsn: 'https://ae9617694dbd4e0184c6b415e979bdfe@o4504467088867328.ingest.sentry.io/4505478123487232',
      environment: process.env.REACT_APP_ENVIRONMENT,
      integrations: [
        new Sentry.BrowserTracing({
          // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: ['localhost', /^https:\/\/api\.pushpulse\.com/],
        }),
        new Sentry.Replay(),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }

  const contentfulClient = new ContentfulClient({
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  });

  ReactDOM.render(
    <ContentfulProvider client={contentfulClient}>
      <App />
    </ContentfulProvider>,
    document.getElementById('root'),
  );
  serviceWorker.unregister();
})();
